import type {ReactNode} from 'react'

import classes from './dispatch-drawer.module.css'

type DrawerJobIdentityProps = {
    customer?: ReactNode
    projectName?: ReactNode
    internalContactName?: string | null
    description?: string
    serviceType?: string
    scheduleLabel?: string
    jobCode?: ReactNode
    siteName?: string
    layout?: 'stack' | 'grid'
}

type IdentityRow = {
    label: string
    value: ReactNode
    testId?: string
}

/** Labeled identity rows below the job title. */
export function DrawerJobIdentity({
    customer,
    projectName,
    internalContactName,
    description,
    serviceType,
    scheduleLabel,
    jobCode,
    siteName,
    layout = 'stack',
}: DrawerJobIdentityProps) {
    const rows: IdentityRow[] = []
    if (serviceType) {
        rows.push({label: 'Work category', value: serviceType, testId: 'drawer-service-type'})
    }
    if (customer) {
        rows.push({label: 'Customer', value: customer})
    }
    if (projectName) {
        rows.push({label: 'Order', value: projectName})
    }
    rows.push({label: 'Rep', value: internalContactName ?? 'Unassigned', testId: 'drawer-rep'})
    if (scheduleLabel) {
        rows.push({label: 'Schedule', value: scheduleLabel})
    }
    if (jobCode) {
        rows.push({label: 'Job Number', value: jobCode})
    }
    if (siteName) {
        rows.push({label: 'Site', value: siteName, testId: 'drawer-contact'})
    }

    if (!description && rows.length === 0) {
        return null
    }

    const blockClass =
        layout === 'grid'
            ? `${classes.identityBlock} ${classes.identityBlockGrid}`
            : classes.identityBlock

    return (
        <dl className={blockClass} data-testid="drawer-identity">
            {description ? (
                <div
                    className={
                        layout === 'grid'
                            ? `${classes.identityDescriptionRow} ${classes.identityDescriptionRowGrid}`
                            : classes.identityDescriptionRow
                    }
                    data-testid="drawer-description"
                >
                    <div className={classes.identityDescriptionValue}>{description}</div>
                </div>
            ) : null}
            {rows.map((row) => (
                <div key={row.label} className={classes.identityRow} data-testid={row.testId}>
                    <dt className={classes.identityLabel}>{row.label}</dt>
                    <dd className={classes.identityValue}>{row.value}</dd>
                </div>
            ))}
        </dl>
    )
}
